<template>
  <div class="appoveDetail">
    <div class="appoveDetail-content">
      <div class="appoveDetail-content-left">
        <div class="tip">
          <Alert show-icon v-if="companyLimit.status == 0" class="review">
            <Icon type="md-time" slot="icon"></Icon>
            审核中
          </Alert>
          <Alert type="success" show-icon v-if="companyLimit.status == 1">
            审核通过
          </Alert>
          <Alert
            type="error"
            show-icon
            style="color: rgb(237, 64, 20)"
            v-if="companyLimit.status == 2"
          >
            已驳回
            <span class="tipRight_ lineBreak"
              >原因：{{ companyLimit.rejectCause || 暂无原因 }}</span
            >
          </Alert>
        </div>
        <div class="topTit">
          <p>申请内容</p>
        </div>
        <div class="infokv">
          <label>账号主体：</label>
          <div>{{ sacCompany.name }}</div>
        </div>
        <div class="infokv">
          <label>申请时间：</label>
          <div>{{ companyLimit.createTime }}</div>
        </div>
        <div class="infokv">
          <label>配额数量：</label>
          <div>{{ companyLimit.applyLimit }}</div>
        </div>
        <div class="infokv">
          <label>申请原因：</label>
          <div class="lineBreak">{{ companyLimit.cause }}</div>
        </div>
        <div class="topTit">
          <p>配额使用情况</p>
        </div>
        <Table
          id="myTable"
          class="tableType"
          ref="tableRef"
          hightlight-row
          :columns="columns3"
          :data="detail"
        ></Table>
        <div v-if="companyLimit.status == 2">
          <div class="topTit1">
            <p>审批结果</p>
          </div>
          <div class="infokv">
            <label>审批人：</label>
            <div>{{ companyLimit.approver }}</div>
          </div>
          <div class="infokv">
            <label>审批时间：</label>
            <div>{{ companyLimit.auditTime }}</div>
          </div>
          <div class="infokv">
            <label>驳回原因：</label>
            <div class="lineBreak">{{ companyLimit.rejectCause }}</div>
          </div>
        </div>
        <div class="appoveDetail-content-left-item">
          <p class="returnBtn">
            <!-- 审核通过 -->

            <!-- 审核驳回 -->
            <span v-permission="['audit']">
              <Poptip
                class="poptip"
                confirm
                transfer
                placement="top"
                @on-ok="checkPass"
                @on-cancel="cancelCheckPass"
                title="确认通过审核吗？"
              >
                <Button
                  class="btn1"
                  type="primary"
                  v-if="companyLimit.status == 0"
                  >审核通过</Button
                >
              </Poptip>
              <Button
                class="btn2"
                type="error"
                v-if="companyLimit.status == 0"
                @click="seeEdit"
                >驳回</Button
              >
            </span>

            <Button class="btn" @click="link('/appove/appovelist')"
              >返回</Button
            >
          </p>
        </div>
      </div>
      <div class="appoveDetail-content-right">
        <div class="rightTop">
          <p class="setTit">
            已配置数量
            <Tooltip
              max-width="1000"
              content="AI服务与视频资源配置额度，单个服务配置一个视频资源配置额度消耗1次，依次累计"
              placement="top-start"
            >
              <img
                class="fontcursor"
                src="@/assets/img/overview/altimg.png"
                alt
                style="
                  margin-left: 3px;
                  margin-top: -16px;
                  position: absolute;
                  width: 10px;
                  height: 10px;
                "
              />
            </Tooltip>
          </p>
          <p
            :class="
              appoveDetail.setCountMore < appoveDetail.setCount
                ? 'countMoreColor setCountMore'
                : 'countColor setCountMore'
            "
          >
            {{ sacCompany.applicationLimitUsed }}
          </p>
          <p class="setCount">/{{ sacCompany.applicationLimit }}</p>
          <div class="setCountImg">
            <img src="~@/assets/img/service/setCount.png" alt="" />
          </div>
        </div>
        <div class="rightBottom">
          <div class="top"></div>
          <div class="commitlist">
            <div
              class="commititem mb-16"
              v-for="(item, index) in history"
              :key="index"
            >
              <div class="flexsb">
                <div>
                  <p v-if="item.status != 2">第{{ item.submitMsg }}次提交</p>
                  <p v-if="item.status == 2">已驳回</p>
                  <p class="mt-4">
                    {{ item.createTime || "暂无" }}
                  </p>
                </div>
                <div>
                  <img src="@/assets/img/video/commit_item.png" alt="" />
                </div>
              </div>
              <div v-if="item.status == 2" class="reason mt-16 pt-16 lineBreak">
                原因：{{ item.rejectCause || "无原因" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 驳回原因 -->
      <applyDown
        v-if="showEdit"
        @close="showEdit = false"
        @confirm="showEdit = false"
        :form="propForm"
      />
    </div>
  </div>
</template>

<script>
import { getQuotaDetail, checkPass } from "@/api/appove";
import applyDown from "./components/ApplyDown";

export default {
  components: { applyDown },
  data() {
    return {
      id: "0",
      showEdit: false,
      propForm: {},
      appoveDetail: {},
      historyList: [{}],
      columns3: [
        {
          title: "应用名称",
          key: "name",
          align: "center",
        },
        {
          title: "配置使用量",
          key: "size",
          align: "center",
        },
      ],
      data1: [],
      companyLimit: {},
      history: [],
      sacCompany: {},
      detail: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  mounted() {},
  methods: {
    // 获取配额详情
    getDetail() {
      getQuotaDetail(this.id)
        .then((res) => {
          this.companyLimit = res.data.data.companyLimit;
          this.history = res.data.data.history;
          this.sacCompany = res.data.data.sacCompany;
          this.detail = res.data.data.detail;
          console.log("=========", res);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 审核通过
    checkPass() {
      // 认证审核通过
      checkPass(this.id)
        .then((res) => {
          console.log("res", res);
          this.$Message.success("配额审批审核通过");
          this.$router.push({ path: "/appove/appovelist" });
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    // 审核通过取消
    cancelCheckPass() {
      console.log("审核通过取消");
    },
    //驳回
    seeEdit() {
      this.propForm = {
        id: this.id,
      };
      this.showEdit = true;
    },
    //页面跳转
    link(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>

<style lang="scss">
.appoveDetail {
  width: 100%;
  min-height: 100%;
  &-content {
    width: calc(100% - 10px);
    min-height: 100%;
    display: flex;
    justify-content: space-between;
    &-left {
      width: calc(100% - 430px);
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
      border-radius: 8px;
      box-sizing: border-box;
      padding: 20px;
      min-height: 100%;
      overflow: auto;
      .tip {
        .ivu-alert {
          color: rgb(140, 230, 176);
        }
        .tipRight {
          margin-left: 30px;
        }
        .tipRight_ {
          margin-left: 30px;
          color: rgb(237, 64, 20);
        }
        .review {
          background-color: #d4e3fd;
          border-color: #568bf7;
          color: #568bf7;
          .ivu-alert-icon {
            margin-top: 2px;
          }
        }
      }
      .topTit,
      .topTit1 {
        font-size: 16px;
        font-family: MicrosoftYaHeiSemibold;
        color: #2f4061;
        font-weight: bold;
        border-bottom: 1px solid #ebedf0;
        box-sizing: border-box;
        padding: 10px 0px;
      }
      .topTit1 {
        margin-top: 30px;
      }
      .tableType {
        margin-top: 20px;
      }
      #myTable .ivu-table th {
        text-align: center;
      }
      &-item {
        .returnBtn {
          display: flex;
          margin-top: 20px;
          margin-bottom: 20px;
          .btn {
            width: 104px;
            height: 36px;
            background: #ffffff;
            border-radius: 18px;
            border: 1px solid #dcdfe6;
            margin-left: 20px;
          }
          .btn1,
          .btn2 {
            width: 104px;
            height: 36px;
            border-radius: 18px;
            margin-left: 20px;
          }
        }
      }
    }
    &-right {
      width: 410px;
      min-height: 100%;
      .rightTop,
      .rightBottom {
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
        border-radius: 8px;
      }
      .rightTop {
        box-sizing: border-box;
        padding: 20px;
        height: 350px;
        .setTit {
          font-size: 16px;
          font-family: MicrosoftYaHeiSemibold;
          color: #67799c;
          font-weight: bold;
          margin-bottom: 25px;
        }
        .setCountMore {
          font-size: 28px;
          font-family: MicrosoftYaHei;
          color: #f56c6c;
        }
        .setCount {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #67799c;
        }
        .setCountImg {
          > img {
            width: 340px;
            height: 146px;
            margin-top: 40px;
            margin-left: 50px;
          }
        }
      }
      .rightBottom {
        margin-top: 20px;
        height: 480px;
        overflow: auto;
        > .top {
          height: 118px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #dcdfe6;
          padding: 24px;
          background-image: url("~@/assets/img/video/commit_img.png");
          background-repeat: no-repeat;
          background-size: 100%;
          .line {
            width: 32px;
            height: 2px;
            background: #3c8aff;
          }
        }
        > .commitlist {
          padding: 16px 24px;
          height: calc(100% - 118px);
          overflow: auto;
          .commititem {
            width: 100%;
            padding: 12px 24px;
            background: rgba(220, 223, 230, 0.1);
            border: 1px dashed #dcdfe6;
            border-radius: 4px;
            .reason {
              border-top: 1px solid rgba(246, 247, 249, 1);
            }
          }
        }
        > .commitlist div:last-child {
          margin-bottom: 0px;
        }
      }
      .countMoreColor {
        color: #f56c6c !important;
      }
      .countColor {
        color: #67c23a !important;
      }
    }
  }
}
</style>